import adminApiClient from './apiClient.js';

export const ajudaApi = {
  list: async (params = {}) => {
    const { data } = await adminApiClient.get('/ajuda/', { params });
    return data;
  },
  get: async (id) => {
    const { data } = await adminApiClient.get(`/ajuda/${id}`);
    return data;
  },
  create: async (payload) => {
    const { data } = await adminApiClient.post('/ajuda/', payload);
    return data;
  },
  update: async (id, payload) => {
    const { data } = await adminApiClient.put(`/ajuda/${id}`, payload);
    return data;
  },
  delete: async (id) => {
    const { data } = await adminApiClient.delete(`/ajuda/${id}`);
    return data;
  },
  deletePermanente: async (id) => {
    const { data } = await adminApiClient.delete(`/ajuda/${id}/permanente`);
    return data;
  },
  resumo: async () => {
    const { data } = await adminApiClient.get('/ajuda/resumo');
    return data;
  },
  listFeedback: async (params = {}) => {
    const { data } = await adminApiClient.get('/ajuda/feedback', { params });
    return data;
  },
  deleteFeedback: async (id) => {
    const { data } = await adminApiClient.delete(`/ajuda/feedback/${id}`);
    return data;
  },
  listInsights: async (params = {}) => {
    const { data } = await adminApiClient.get('/ajuda/insights', { params });
    return data;
  },
  deleteInsights: async (id) => {
    const { data } = await adminApiClient.delete(`/ajuda/insights/${id}`);
    return data;
  },
};

export default ajudaApi;
